var ɵ0 = window;
var CmsSharedModule = /** @class */ (function () {
    function CmsSharedModule() {
    }
    return CmsSharedModule;
}());
export { CmsSharedModule };
export { ɵ0 };
